import styled from "styled-components";

export const CountryLink = styled.a`
  margin-left: 8px; 
  margin-right: 8px; 
  color: #e6000f;
  opacity: 1;
  text-decoration: none;
  cursor: pointer;

  &:hover {
  text-decoration: underline;
  text-decoration: none;

  }
`;

export const ButtonWrapperStyles = styled.div`
  display: flex;
  gap: 5px;
  margin-top: 16px;
`;
